// This component is positioned at the top of every page except Login/SignUp
// Used for
// 	- navigating to home
// 	- logging out from account
// 	- saving playbooks
// Some parts from this component are optionally rendered based on the page it is displayed

import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MenuItem, Select } from '@mui/material';
import {
  AcceptRejectDialog,
  NotificationDialog,
  PopUpSpinner,
} from '../../CommonFunctions/DialogComponents';
import { useNavigate } from 'react-router-dom';
import { updatePlaybookUid } from '../../../redux/PlayBook/PlayBookActions';
import { localEndPoint } from '../../ServerCall/EnvironmentVariables';
import AboutPopover from '../../CommonFunctions/PopOverComponents/AboutPopover';
import PrivacyPopover from '../../CommonFunctions/PopOverComponents/PrivacyPopover';
import * as CSS from 'csstype';
import { MenubarProps } from './../MenubarInterfaces';
import FetchData from '../../ServerCall/FetchData';
import '../dataViewer.css';
import { toggleDashModeInTab } from '../../../redux/TabTile/TabActions';
import {
  resetAllStates,
  toggleDashMode,
} from '../../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { SelectListItem } from '../../CommonFunctions/SelectListItem';
import silzilaNewLogo from '../../../assets/new_silzilaLogo.svg';
import { AlertColor } from '@mui/material/Alert';
import useCombinedColorSchemes from '../../../hooks/useCombinedColorSchemes';
import { isColorDark } from '../../ChartOptions/Color/ChartColorComponents/colorUtils';
import isEqual from 'lodash/isEqual';
import {
  areNestedObjectsEqual,
  ConvertListOfListToRichTreeViewList,
  DeleteAllCookies,
  deletePlaybookDetailsFromSessionStorage,
  GetWorkSpaceDetails,
  isNameAllowed,
} from '../../CommonFunctions/CommonFunctions';
import Logger from '../../../Logger';
import Header from '../../../Components/Header';
import { RootState } from '../../../redux';
import { fromRoute, messages, navigatetTo } from '../../CommonFunctions/aliases';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { ignoreKeys } from '../MenuBar/constants';
import HomeIcon from '../MenuBar/HomeIcon';
import DataViewerMenu from '../MenuBar/DataViewerMenu';
import DataViewerHeader from '../MenuBar/DataViewerHeader';
import SaveModal from '../MenuBar/SaveModal';
import { useDispatch } from 'react-redux';

import EditIcon from '@mui/icons-material/Edit';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import TvIcon from '@mui/icons-material/Tv';
import {
  callQueryAPI,
  updateUserSelection,
  updateUserSelectionColumn,
} from '../../../redux/ChartPoperties/ChartControlsActions';

const MenuBar = ({
  // props
  from,
  isOpeningSharedLink,
  disableEdit,
  showListofTileMenu,
  setShowListofTileMenu,
  dashboardResizeColumn,
  setDashboardResizeColumn,
  showDashboardFilter,
  setShowDashboardFilter,
  showDashboardFilterEdit,
  setShowDashboardFilterEdit,
  iconAlign,
  setIconAlign,
  reportFilterMenu,
  setReportFilterMenu,
  parameterMenu,
  setParameterMenu,
  // state
  // token,
  // tabTileProps,
  // tabState,
  // tileState,
  // playBookState,
  // chartProperty,
  // chartControl,
  // chartGroup,
  // dynamicMeasureState,
  // calculations,
  // dashBoardFilterGroup,
  //dispatch
  // toggleDashMode,
  // toggleDashModeInTab,
  // updatePlayBookId,
  // resetAllStates,
}: MenubarProps) => {
  var showSaveWarning: boolean = false;

  const location = useLocation();
  const state = location.state;

  const {
    tabTileProps,
    tabState,
    tileState,
    playBookState,
    chartProperty,
    chartControl,
    chartGroup,
    dynamicMeasureState,
    calculations,
    dashBoardFilterGroup,
    parameters,
    pageSettings,
  } = useSelector((state: RootState) => ({
    tabTileProps: state.tabTileProps,
    tabState: state.tabState,
    tileState: state.tileState,
    playBookState: state.playBookState,
    chartProperty: state.chartProperties,
    chartControl: state.chartControls,
    chartGroup: state.chartFilterGroup,
    dynamicMeasureState: state.dynamicMeasuresState,
    calculations: state.calculations,
    dashBoardFilterGroup: state.dashBoardFilterGroup,
    parameters: state.parameters,
    pageSettings: state.pageSettings,
  }));

  const dispatch = useDispatch<any>();
  const propKey = useMemo(
    () => `${tabTileProps?.selectedTabId}.${tabTileProps?.selectedTileId}`,
    [tabTileProps?.selectedTabId, tabTileProps?.selectedTileId],
  );
  const token = Cookies.get('authToken');
  const [searchParams] = useSearchParams();
  const workspaceId = searchParams.get('workspaceId');
  const playbookId = searchParams.get('playbookId');

  // Check if the current state of playbook is the same as old state or not
  if (from === 'dataViewer' && playBookState.oldContent) {
    if (
      isEqual(tabState, playBookState.oldContent.tabState) &&
      isEqual(tileState, playBookState.oldContent.tileState) &&
      isEqual(tabTileProps, playBookState.oldContent.tabTileProps) &&
      isEqual(chartProperty, playBookState.oldContent.chartProperty) &&
      isEqual(chartControl, playBookState.oldContent.chartControl) &&
      isEqual(chartGroup, playBookState.oldContent.chartGroup) &&
      isEqual(dynamicMeasureState, playBookState.oldContent.dynamicMeasureState)
      // JSON.stringify(tabState) === JSON.stringify(playBookState.oldContent.tabState) &&
      // JSON.stringify(tileState) === JSON.stringify(playBookState.oldContent.tileState) &&
      // JSON.stringify(tabTileProps) ===
      // 	JSON.stringify(playBookState.oldContent.tabTileProps) && //*
      // JSON.stringify(chartProperty) ===
      // 	JSON.stringify(playBookState.oldContent.chartProperty) &&
      // JSON.stringify(chartControl) ===
      // 	JSON.stringify(playBookState.oldContent.chartControl) && //*
      // JSON.stringify(chartGroup) === JSON.stringify(playBookState.oldContent.chartGroup) &&
      // JSON.stringify(dynamicMeasureState) ===
      // JSON.stringify(playBookState.oldContent.dynamicMeasureState)
    ) {
      showSaveWarning = false;
    } else {
      showSaveWarning = true;
    }
  }

  const menuStyle: CSS.Properties = {
    fontSize: '12px',
    padding: '2px 8px',
    margin: 0,
  };

  // values for opening file menu and setting its anchor position
  const [openFileMenu, setOpenFileMenu] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<any>(null);

  // Open / Close about popOver
  const [aboutPopover, setAboutPopover] = useState<boolean>(false);

  // Open / Close privacy popOver
  const [privacyPopover, setPrivacyPopover] = useState<boolean>(false);

  // Save dataset modal Open / Close , playbook name and description
  const [saveModal, setSaveModal] = useState<boolean>(false);
  const [playBookName, setPlayBookName] = useState<string>(playBookState?.playBookName || '');
  const [playBookDescription, setPlayBookDescription] = useState<string | null>(
    playBookState.description,
  );

  // Success / Failure alert modal
  const [severity, setSeverity] = useState<AlertColor>('success');
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [testMessage, setTestMessage] = useState<string>('');

  // value to identify if save action is called because Home icon was clicked
  const [saveFromHomeIcon, setSaveFromHomeIcon] = useState<boolean>(false);
  const [saveFromLogoutIcon, setSaveFromLogoutIcon] = useState<boolean>(false);
  const [openSaveCalculationDialogFromHomeIcon, setOpenSaveCalculationDialogFromHomeIcon] =
    useState(false);

  const [selectOpen, setSelectOpen] = useState(false);

  const [subWorkspaceList, setSubWorkspaceList] = useState<Array<Object>>([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState<string>('');
  const [isSubWorkspaceSelected, setIsSubWorkspaceSelected] = useState<boolean>(false);
  // const [disableEdit, setDisableEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [saveFromUpdateProfile, setSaveFromUpdateProfile] = useState<boolean>(false);
  const [saveFromSettings, setSaveFromSettings] = useState(false);
  const [saveFromTvDisplay, setSaveFromTvDisplay] = useState<boolean>(false);

  useEffect(() => {
    if (!playBookState?.playBookName) {
      console.log('playbook name is not set');
      return;
    }
    setPlayBookName(playBookState?.playBookName);
  }, [playBookState]);

  const allThemes = useCombinedColorSchemes();

  const { menuBarBackgroundColor, menuBarTextColor, menuBarBorderColor } = useMemo(() => {
    if (!tabTileProps.showDash) {
      return {
        menuBarBackgroundColor: '#ffffff', // Default white background
        menuBarTextColor: '#333', // Default dark grey text
        menuBarBorderColor: '#cccccc', // Default light grey border
      };
    }
    const activeTabId = tabTileProps.selectedTabId;
    if (!activeTabId) {
      return {
        menuBarBackgroundColor: '#ffffff',
        menuBarTextColor: '#333',
        menuBarBorderColor: '#666666',
      };
    }
    const dashTheme = tabState.tabs[activeTabId]?.dashboardState?.colorScheme;
    const scheme_passed =
      dashTheme ??
      chartControl.properties[Object.keys(chartControl.properties)[0]]?.colorScheme ??
      'peacock';
    const selectedScheme = allThemes.find((scheme) => scheme.name === scheme_passed);

    let isDark = false; // Default to light
    if (selectedScheme) {
      if (selectedScheme.dark !== undefined) {
        isDark = selectedScheme.dark === true;
      } else if (selectedScheme.background) {
        isDark = isColorDark(selectedScheme.background);
      }
    }
    return {
      menuBarBackgroundColor: selectedScheme ? selectedScheme.background : '#ffffff',
      menuBarTextColor: isDark ? '#ffffff' : '#333',
      menuBarBorderColor: isDark ? '#a0a0a0' : '#a7a6a6ff',
    };
  }, [tabTileProps.showDash, tabState, tabTileProps.selectedTabId, chartControl, allThemes]);
  // useEffect(() => {
  //   const getPrivilegeforPlayBook = async () => {
  //     const permissionRes = await FetchData({
  //       requestType: 'noData',
  //       method: 'GET',
  //       url: `privilege?workspaceId=${state?.parentId}&contentTypeId=${contentTypes.Playbook}&contentId=${playBookState.playBookUid}`,
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     if (permissionRes.status) {
  //       setDisableEdit(!permissionRes.data.levelId || permissionRes.data.levelId === 3);
  //     } else return;
  //   };

  //   if (from === 'dataViewer') getPrivilegeforPlayBook();
  // }, [playBookState]);

  const handleDirectClick = (selectedWorkspaceID: string, list: any) => {
    setIsSubWorkspaceSelected(!list.find((item: any) => item.id === selectedWorkspaceID));
    setSelectedWorkspace(selectedWorkspaceID);
  };

  const getAllSubworkspace = async () => {
    setLoading(true);
    var result = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url: `workspaces/tree`,
      headers: { Authorization: `Bearer ${token}` },
    });

    let list = [];

    if (result.status) {
      list = result.data;
      setLoading(false);
    } else {
      Logger('error', result.error??'error');
      setLoading(false);
    }

    setSubWorkspaceList(ConvertListOfListToRichTreeViewList(list));
  };

  useEffect(() => {
    getAllSubworkspace();
  }, []);
  var navigate = useNavigate();
  useEffect(() => {
    if (!state && !workspaceId && !playbookId) {
      navigate('/');
    }
  }, [state, workspaceId, playbookId, navigate]);
  if (!state && !workspaceId && !playbookId) {
    return null;
  }

  //The below function can be called from 3 different user actions
  //		1. Save playbook
  //		2. Home button clicked
  //		3. Logout clicked
  function logout() {
    // setTimeout(() => {

    sessionStorage.setItem('isLoggingOut', 'true');

    let authToken: any = Cookies.get('authToken');
    if (window.location.protocol === 'https:') {
      let decodedToken: any = null;
      if (authToken) {
        decodedToken = jwtDecode(authToken);

        sessionStorage.setItem('accessType', decodedToken?.access); // To store the access type of the user for navigation to login page
      }
      DeleteAllCookies();
      Cookies.remove('authToken');
      Cookies.remove('authToken', {
        path: '/',
        domain: new URL(localEndPoint || '').hostname,
      });
      localStorage.clear();

      localStorage.setItem('isLoggingOut', 'true'); // to prevent default popup coming on navigation
      window.history.pushState(null, '', '/');
      window.location.href = `${localEndPoint}auth/logout`;
      window.location.reload(); // Reload the page for running the useEffect hook

      // commented code might be useful if on logout we want to redirect to different logout urls based on access type
      // if (authToken && decodedToken?.access === 'community') {
      //   localStorage.setItem('isLoggingOut', 'true'); // to prevent default popup coming on navigation
      //   window.history.pushState(null, '', '/');
      //   window.location.href = `${localEndPoint}auth/logout`;
      //   window.location.reload(); // Reload the page for running the useEffect hook
      // } else {
      //   localStorage.setItem('isLoggingOut', 'true'); // to prevent default popup coming on navigation
      //   window.history.pushState(null, '', '/');
      //   window.location.href = `${localEndPoint}auth/logout`;
      //   window.location.reload(); // Reload the page for running the useEffect hook
      // }
    } else {
      DeleteAllCookies();
      Cookies.remove('authToken');
      Cookies.remove('authToken', {
        path: '/',
        domain: new URL(localEndPoint || '').hostname,
      });
      localStorage.clear();

      localStorage.setItem('isLoggingOut', 'true'); // to prevent default popup coming on navigation
      window.history.pushState(null, '', '/');
      window.location.href = `${localEndPoint}auth/logout`;
      window.location.reload(); // Reload the page for running the useEffect hook
    }
    // resetUser();
    DeleteAllCookies();
    Cookies.remove('authToken');
    Cookies.remove('authToken', {
      path: '/',
      domain: new URL(localEndPoint || '').hostname,
    });
    localStorage.clear();
    // }, 2000);
  }
  const handleSave = async (saveFromHome?: boolean) => {
    setOpenFileMenu(false);

    if (
      chartControl?.properties[propKey]?.rowSecurity?.filterPanels[
        chartControl?.properties?.[propKey]?.rowSecurity?.currentOperator.toLowerCase()
      ]?.filters.length > 0
    ) {
      dispatch(
        updateUserSelection(
          propKey,
          chartControl?.properties?.[propKey]?.rowSecurity?.currentOperator.toLowerCase(),
          [],
        ),
      );
      dispatch(callQueryAPI(propKey, true));
    }

    if (
      chartControl?.properties[propKey]?.columnSecurity?.filterPanels[
        chartControl?.properties?.[propKey]?.columnSecurity?.currentOperator.toLowerCase()
      ]?.filters.length > 0
    ) {
      dispatch(
        updateUserSelectionColumn(
          propKey,
          chartControl?.properties?.[propKey]?.columnSecurity?.currentOperator.toLowerCase(),
          [],
        ),
      );
      dispatch(callQueryAPI(propKey, true));
    }

    // // 👉 Wait one tick to allow Redux state to update
    // await new Promise((resolve) => setTimeout(resolve, 2000));

    // check if this playbook already has a name / id
    // 		if Yes, save in the same name
    // 		if No, open modal to save in a new name
    if (playBookState.playBookUid && playBookState.playBookUid !== null) {
      setSaveModal(false);
      var playBookObj = formatPlayBookData();

      /*	PRS	11/JUN/2022	Removed extra '/'	*/
      setLoading(true);
      var result = await FetchData({
        requestType: 'withData',
        method: 'PUT',
        url: `playbook/${playBookState.playBookUid}?workspaceId=${
          selectedWorkspace || state?.parentId || workspaceId
        }`,
        data: playBookObj,
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!result.status) {
        setOpenSaveCalculationDialogFromHomeIcon(false);
        setLoading(false);
        setSeverity('error');
        setOpenAlert(true);
        setTestMessage(result.error ?? 'Failed to save playbook');
      } else {
        setOpenSaveCalculationDialogFromHomeIcon(false);
        setLoading(false);
        setSeverity('success');
        setOpenAlert(true);
        setTestMessage('Successfully saved playbook');

        if (
          !saveFromHomeIcon &&
          !saveFromLogoutIcon &&
          !saveFromUpdateProfile &&
          !saveFromSettings
        ) {
          sessionStorage.setItem(
            `pb_id_${playBookState.playBookUid}`,
            JSON.stringify(currPlaybook()),
          );
        }
        setTimeout(() => {
          setOpenAlert(false);
          if (saveFromHome) {
            deletePlaybookDetailsFromSessionStorage();
            navigate('/');
            dispatch(resetAllStates());
          } else if (saveFromLogoutIcon) {
            deletePlaybookDetailsFromSessionStorage();
            // resetUser();

            logout();
            // navigate("/login");/
            dispatch(resetAllStates());
          } else if (saveFromUpdateProfile) {
            deletePlaybookDetailsFromSessionStorage();
            navigate('/update-profile');
            dispatch(resetAllStates());
          } else if (saveFromSettings) {
            deletePlaybookDetailsFromSessionStorage();
            navigate('/settings');
            dispatch(resetAllStates());
          } else if (saveFromTvDisplay) {
            // deletePlaybookDetailsFromSessionStorage();
            const pathParts = window.location.pathname.split('/');
            const dashboardId = pathParts[pathParts.length - 1];
            dispatch(toggleDashMode('TV Display'));
            dispatch(toggleDashModeInTab(tabTileProps.selectedTabId, 'TV Display'));

            navigate(`/display/playbook?workspaceId=${workspaceId}&playbookId=${playbookId}`, {
              state: { ...location.state, disableEdit },
            });
          }
        }, 2000);
      }
    } else {
      setSaveModal(true);
    }
  };

  const filterServerData: any = (obj: any) => {
    if (Array.isArray(obj)) {
      return obj.map((item) => filterServerData(item));
    }

    if (typeof obj === 'object' && obj !== null) {
      const result: Record<string, any> = {};
      for (const key in obj) {
        if (key !== 'serverData' && key !== 'chartData' && key !== 'userSelection') {
          result[key] = filterServerData(obj[key]);
        } else {
          result[key] = []; // Set serverData and chartData to empty arrays
        }
      }
      return result;
    }
    return obj;
  };
  const changeModifiedByToAxis = (chartproperty: any) => {
    if (!chartproperty?.properties || typeof chartproperty.properties !== 'object') {
      return chartproperty; // nothing to update
    }
    const propKeys = Object.keys(chartproperty.properties);
    propKeys.forEach((key: string) => {
      chartproperty.properties[key].modified = 'axis';
    });
    return chartproperty;
  };
  //Format the data to be saved under this playbook
  const formatPlayBookData = () => {
    var playBookObj = {
      name: playBookName?.trim(),
      description: '',
      content: {
        version: 'v2.0', // For this release. Update it when new version is released.
        tabState,
        tileState,
        tabTileProps,
        chartProperty: changeModifiedByToAxis(chartProperty),
        chartControl: filterServerData(chartControl),
        chartGroup,
        dynamicMeasureState,
        calculations,
        dashBoardFilterGroup,
        parameters,
      },
    };

    if (playBookDescription) playBookObj.description = playBookDescription;

    return playBookObj;
  };
  const currPlaybook = () => {
    return {
      version: 'v2.0', // For this release. Update it when new version is released.
      tabState,
      tileState,
      tabTileProps,
      chartProperty,
      chartControl,
      chartGroup,
      dynamicMeasureState,
      dashBoardFilterGroup,
      calculations,
      parameters,
    };
  };

  // Save playbook with a new name
  const savePlaybook = async () => {
    let workSpaceId = selectedWorkspace || state?.parentId || workspaceId;

    if (playBookName.length > 40) {
      setSeverity('error');
      setOpenAlert(true);
      setTestMessage('Playbook name cannot exceed 40 characters.');
      return;
    }

    if (
      chartControl?.properties[propKey]?.rowSecurity?.filterPanels[
        chartControl?.properties?.[propKey]?.rowSecurity?.currentOperator.toLowerCase()
      ]?.filters.length > 0
    ) {
      dispatch(
        updateUserSelection(
          propKey,
          chartControl?.properties?.[propKey]?.rowSecurity?.currentOperator.toLowerCase(),
          [],
        ),
      );
      dispatch(callQueryAPI(propKey, true));
    }

    if (
      chartControl?.properties[propKey]?.columnSecurity?.filterPanels[
        chartControl?.properties?.[propKey]?.columnSecurity?.currentOperator.toLowerCase()
      ]?.filters.length > 0
    ) {
      dispatch(
        updateUserSelectionColumn(
          propKey,
          chartControl?.properties?.[propKey]?.columnSecurity?.currentOperator.toLowerCase(),
          [],
        ),
      );
      dispatch(callQueryAPI(propKey, true));
    }

    if (playBookName && selectedWorkspace && (state?.parentId || workspaceId)) {
      var playBookObj = formatPlayBookData();
      if (!playBookObj.name) {
        setSeverity('error');
        setOpenAlert(true);
        setTestMessage('Playbook name is not set');
        return;
      }
      if (!isNameAllowed(playBookObj.name)) {
        setSeverity('warning');
        setOpenAlert(true);
        setTestMessage(messages.playbook.wrongName);
        return;
      }
      setLoading(true);
      var result= await FetchData({
        requestType: 'withData',
        method: 'POST',
        url: `playbook?workspaceId=${workSpaceId}`,
        data: playBookObj,
        headers: { Authorization: `Bearer ${token}` },
      });

      if (result.status) {
        dispatch(
          updatePlaybookUid(
            result.data.name,
            result.data.id,
            result.data.description,
            JSON.parse(result.data.content),
          ),
        );
        if (
          !saveFromHomeIcon &&
          !saveFromLogoutIcon &&
          !saveFromUpdateProfile &&
          !saveFromSettings
        ) {
          sessionStorage.setItem(`pb_id_${result.data.id}`, result.data.content);
        }
        setSaveModal(false);
        setLoading(false);
        setOpenSaveCalculationDialogFromHomeIcon(false);
        setSeverity('success');
        setOpenAlert(true);
        setTestMessage('Successfully saved playbook');
        setTimeout(() => {
          if (saveFromTvDisplay) {
            // deletePlaybookDetailsFromSessionStorage();
            const pathParts = window.location.pathname.split('/');
            const dashboardId = pathParts[pathParts.length - 1];
            dispatch(toggleDashMode('TV Display'));
            dispatch(toggleDashModeInTab(tabTileProps.selectedTabId, 'TV Display'));

            navigate(`/display/playbook?workspaceId=${workspaceId}&playbookId=${result.data.id}`, {
              state: { ...location.state, disableEdit },
            });
            return;
          }
          if (saveFromHomeIcon) {
            deletePlaybookDetailsFromSessionStorage();
            if (isSubWorkspaceSelected) {
              let workspaceDetail: any = GetWorkSpaceDetails(subWorkspaceList, workSpaceId, true);
              localStorage.setItem('workspaceName', workspaceDetail?.label);
              localStorage.setItem('childWorkspaceName', workspaceDetail.subLabel);
              localStorage.setItem('parentId', workSpaceId);

              navigate(`/SubWorkspaceDetails/${workSpaceId}`, {
                state: { childWorkspaceName: workspaceDetail.subLabel },
              });
              dispatch(resetAllStates());
            } else {
              let workspaceDetail: any = GetWorkSpaceDetails(subWorkspaceList, workSpaceId);
              localStorage.setItem('workspaceName', workspaceDetail?.label);
              localStorage.setItem('parentId', workSpaceId);
              dispatch(resetAllStates());
              navigate(`/workspace/${workSpaceId}`);
            }

            if (
              chartControl?.properties[propKey]?.rowSecurity?.filterPanels[
                chartControl?.properties?.[propKey]?.rowSecurity?.currentOperator.toLowerCase()
              ]?.filters.length > 0
            ) {
              dispatch(
                updateUserSelection(
                  propKey,
                  chartControl?.properties?.[propKey]?.rowSecurity?.currentOperator.toLowerCase(),
                  [],
                ),
              );
              dispatch(callQueryAPI(propKey, true));
            }
            if (
              chartControl?.properties[propKey]?.columnSecurity?.filterPanels[
                chartControl?.properties?.[propKey]?.columnSecurity?.currentOperator.toLowerCase()
              ]?.filters.length > 0
            ) {
              dispatch(
                updateUserSelectionColumn(
                  propKey,
                  chartControl?.properties?.[
                    propKey
                  ]?.columnSecurity?.currentOperator.toLowerCase(),
                  [],
                ),
              );
              dispatch(callQueryAPI(propKey, true));
            }
            //navigate("/");
          } else if (saveFromLogoutIcon) {
            deletePlaybookDetailsFromSessionStorage();

            logout();
            // navigate("/login");
            dispatch(resetAllStates());
          } else if (saveFromUpdateProfile) {
            deletePlaybookDetailsFromSessionStorage();
            navigate('/update-profile');
            setTimeout(() => dispatch(resetAllStates()), 10);
          } else if (saveFromSettings) {
            deletePlaybookDetailsFromSessionStorage();
            navigate('/settings');
            setTimeout(() => dispatch(resetAllStates()), 10);
          } else {
            deletePlaybookDetailsFromSessionStorage();
            navigate(
              `/playbook?workspaceId=${result.data.workspaceId}&playbookId=${result.data.id}`,
              {
                replace: true,
                state: {
                  mode: 'Save',
                  parentId: result.data.workspaceId,
                  playbookId: result.data.id,
                },
              },
            );
          }

          /*	PRS	14Nov2024	Fresh save play book*/
          //resetAllStates();
          setOpenAlert(false);
        }, 2000);
      } else {
        setLoading(false);
        setOpenSaveCalculationDialogFromHomeIcon(false);
        setSeverity('error');
        setOpenAlert(true);
        setTestMessage(result.error ?? 'Failed to save playbook');
        // setTimeout(() => {
        // 	setOpenAlert(false);
        // }, 2000);
      }
    } else {
      setSeverity('error');
      setOpenAlert(true);
      setTestMessage('Provide a Playbook name & select a workspace');

      // setTimeout(() => {
      // 	setOpenAlert(false);
      // }, 2000);
    }
  };

  function saveAndNavigateTo(routeTo: string): void {
    if (disableEdit) {
      if (routeTo === navigatetTo.login) logout();
      else if (routeTo === navigatetTo.updateProfile) navigate('/update-profile');
      else if (routeTo === navigatetTo.settings) navigate('/settings');
      else if (routeTo === navigatetTo.tvDisplay) {
        const pathParts = window.location.pathname.split('/');
        const dashboardId = pathParts[pathParts.length - 1];
        dispatch(toggleDashMode('TV Display'));
        dispatch(toggleDashModeInTab(tabTileProps.selectedTabId, 'TV Display'));
        navigate(`/display/playbook?workspaceId=${workspaceId}&playbookId=${playbookId}`, {
          state: { ...location.state, disableEdit },
        });
      }
      setTimeout(() => dispatch(resetAllStates()), 10);
      return;
    }

    if (
      areNestedObjectsEqual(
        sessionStorage.getItem(`pb_id_${playBookState.playBookUid}`) || '',
        JSON.stringify(currPlaybook()),
        ignoreKeys,
      )
    ) {
      if (routeTo !== navigatetTo.tvDisplay) deletePlaybookDetailsFromSessionStorage();
      // sessionStorage.removeItem(`pb_id_${playBookState.playBookUid}`);
      if (routeTo === navigatetTo.login) logout();
      else if (routeTo === navigatetTo.updateProfile) navigate('/update-profile');
      else if (routeTo === navigatetTo.settings) navigate('/settings');
      else if (routeTo === navigatetTo.tvDisplay) {
        const pathParts = window.location.pathname.split('/');
        const dashboardId = pathParts[pathParts.length - 1];

        dispatch(toggleDashMode('TV Display'));
        dispatch(toggleDashModeInTab(tabTileProps.selectedTabId, 'TV Display'));
        navigate(`/display/playbook?workspaceId=${workspaceId}&playbookId=${playbookId}`, {
          state: { ...location.state, disableEdit },
        });
      }
      if (
        routeTo === navigatetTo.login ||
        routeTo === navigatetTo.updateProfile ||
        routeTo === navigatetTo.settings
      ) {
        setTimeout(() => dispatch(resetAllStates()), 10);
      }
    } else {
      if (routeTo === navigatetTo.login) setSaveFromLogoutIcon(true);
      else if (routeTo === navigatetTo.updateProfile) setSaveFromUpdateProfile(true);
      else if (routeTo === navigatetTo.settings) setSaveFromSettings(true);
      else if (routeTo === navigatetTo.tvDisplay) setSaveFromTvDisplay(true);

      setOpenSaveCalculationDialogFromHomeIcon(true);
    }
  }

  useEffect(() => {
    const handleSaveFromTvDisplay = () => {
      saveAndNavigateTo(navigatetTo.tvDisplay);
    };

    window.addEventListener('saveFromTvDisplay', handleSaveFromTvDisplay);

    return () => {
      window.removeEventListener('saveFromTvDisplay', handleSaveFromTvDisplay);
    };
  }, [saveAndNavigateTo, navigatetTo]);

  const menubarDropdownColor = menuBarTextColor === '#ffffff' ? menuBarTextColor : '#646363';

  /**
   *
   * @returns two menu Items for exporting. These options are enabled only for dashboard i.e. when showDash === true in tabTileProps object.
   */

  return (
    <div
      className="dataViewerMenu"
      style={{
        padding: '0.5rem',
        borderBottom:
          from === 'fileUpload' || from === 'editFlatFile' || from === 'saveFlaFile'
            ? '2px solid rgba(224,224,224,1)'
            : 'none',
        display: pageSettings.fullScreen ? 'none' : '',
        backgroundColor: menuBarBackgroundColor,
      }}
    >
      <SelectListItem
        render={(xprops: any) => (
          <div>
            {!isOpeningSharedLink ? (
              <HomeIcon
                currPlaybook={currPlaybook}
                disableEdit={disableEdit}
                from={from}
                setOpenSaveCalculationDialogFromHomeIcon={setOpenSaveCalculationDialogFromHomeIcon}
                setSaveFromHomeIcon={setSaveFromHomeIcon}
                setSaveModal={setSaveModal}
                showSaveWarning={showSaveWarning}
                xprops={xprops}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexFlow: 'row',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
                onClick={() => window.open(localEndPoint, '_blank')}
              >
                <img
                  src={silzilaNewLogo}
                  style={{
                    // height: "100%",
                    height: '1.625rem',
                    // width: "3rem",
                    width: '1.625rem',
                    // padding: "4px 4px 4px 6px",
                    // margin: "4px 0px 0px 2px",
                    marginRight: '5px',
                  }}
                  alt="Silzila Home"
                />
                <h2 style={{ color: menuBarTextColor }}>Silzila</h2>
              </div>
            )}
          </div>
        )}
      />

      {openSaveCalculationDialogFromHomeIcon && from === 'dataViewer' ? (
        <AcceptRejectDialog
          open={openSaveCalculationDialogFromHomeIcon}
          closeFunction={() => {
            setOpenSaveCalculationDialogFromHomeIcon(false);
            setSaveFromHomeIcon(false);
            setSaveFromLogoutIcon(false);
            setSaveFromUpdateProfile(false);
            setSaveFromSettings(false);
            setSaveFromTvDisplay(false);
          }}
          acceptFunction={() => {
            if (
              chartControl?.properties[propKey]?.rowSecurity?.filterPanels[
                chartControl?.properties?.[propKey]?.rowSecurity?.currentOperator.toLowerCase()
              ]?.filters.length > 0
            ) {
              dispatch(
                updateUserSelection(
                  propKey,
                  chartControl?.properties?.[propKey]?.rowSecurity?.currentOperator.toLowerCase(),
                  [],
                ),
              );
              dispatch(callQueryAPI(propKey, true));
            }
            if (
              chartControl?.properties[propKey]?.columnSecurity?.filterPanels[
                chartControl?.properties?.[propKey]?.columnSecurity?.currentOperator.toLowerCase()
              ]?.filters.length > 0
            ) {
              dispatch(
                updateUserSelectionColumn(
                  propKey,
                  chartControl?.properties?.[
                    propKey
                  ]?.columnSecurity?.currentOperator.toLowerCase(),
                  [],
                ),
              );
              dispatch(callQueryAPI(propKey, true));
            }
            if (saveFromTvDisplay) {
              handleSave();
            } else {
              handleSave(saveFromHomeIcon);
            }
          }}
          rejectFunction={() => {
            if (saveFromTvDisplay) {
              setOpenSaveCalculationDialogFromHomeIcon(false);
              setSaveFromTvDisplay(false);
              return;
            }

            deletePlaybookDetailsFromSessionStorage();
            setOpenSaveCalculationDialogFromHomeIcon(false);

            saveFromLogoutIcon
              ? logout()
              : navigate(
                  saveFromUpdateProfile ? '/update-profile' : saveFromSettings ? '/settings' : '/',
                );

            setSaveFromHomeIcon(false);
            setSaveFromLogoutIcon(false);
            setSaveFromUpdateProfile(false);
            setSaveFromSettings(false);
            setSaveFromTvDisplay(false);

            dispatch(resetAllStates());
          }}
          heading="Save playbook"
          messages={[
            {
              text: saveFromTvDisplay
                ? 'Do you want to save the current playbook before going to TV Display mode?'
                : 'Do you want to save the current playbook before closing?',
            },
          ]}
          acceptText="Yes"
          rejectText="No"
          varient="animated"
          rejectButtonStyle={{
            border: '2px solid red',
            color: 'red',

            // "&:focus": { backgroundColor: "red", color: "white" },
          }}
          acceptButtonStyle={{
            border: '2px solid #2bb9bb',
            color: '#2bb9bb',
            // "&:focus": {
            //   background: palette.primary.main,
            //   color: palette.secondary.contrastText,
            // },
          }}
          acceptTransition={{
            transitionTime: '0.2s',
            backgroundColor: 'secondary.contrastText',
            color: 'primary.main',
            hoverBackgroundColor: 'primary.main',
            hoverColor: 'secondary.contrastText',
          }}
          rejectTransition={{
            transitionTime: '0.2s',
            backgroundColor: 'secondary.contrastText',
            color: 'red',
            hoverBackgroundColor: 'red',
            hoverColor: 'secondary.contrastText',
          }}
        />
      ) : (
        <AcceptRejectDialog
          open={openSaveCalculationDialogFromHomeIcon}
          closeFunction={() => {
            setOpenSaveCalculationDialogFromHomeIcon(false);
            setSaveFromHomeIcon(false);
            setSaveFromLogoutIcon(false);
            setSaveFromUpdateProfile(false);
            setSaveFromSettings(false);
            setSaveFromTvDisplay(false);
          }}
          rejectFunction={() => {
            setOpenSaveCalculationDialogFromHomeIcon(false);
            setSaveFromHomeIcon(false);
            setSaveFromLogoutIcon(false);
            setSaveFromUpdateProfile(false);
            setSaveFromSettings(false);
            setSaveFromTvDisplay(false);
          }}
          acceptFunction={() => {
            deletePlaybookDetailsFromSessionStorage();
            // sessionStorage.removeItem(`pb_id_${playBookState.playBookUid}`);
            setOpenSaveCalculationDialogFromHomeIcon(false);
            saveFromLogoutIcon
              ? logout()
              : saveFromTvDisplay
                ? (() => {
                    const pathParts = window.location.pathname.split('/');
                    const dashboardId = pathParts[pathParts.length - 1];
                    navigate(
                      `/display/${dashboardId}?workspaceId=${workspaceId}&playbookId=${playbookId}`,
                      {
                        state: { ...location.state, disableEdit },
                      },
                    );
                  })()
                : navigate(
                    saveFromUpdateProfile
                      ? '/update-profile'
                      : saveFromSettings
                        ? '/settings'
                        : '/',
                  );

            // navigate(
            //   saveFromLogoutIcon
            //     ? "/login"
            //     : saveFromUpdateProfile
            //     ? "/update-profile"
            //     : "/"
            // );
            setSaveFromHomeIcon(false);
            setSaveFromLogoutIcon(false);
            setSaveFromUpdateProfile(false);
            setSaveFromSettings(false);
            setSaveFromTvDisplay(false);
            dispatch(resetAllStates());
          }}
          heading={
            saveFromLogoutIcon
              ? 'Logout'
              : saveFromUpdateProfile
                ? 'Update Profile'
                : saveFromSettings
                  ? 'Settings'
                  : saveFromTvDisplay
                    ? 'TV Display'
                    : ''
          }
          messages={[
            {
              text: 'Do you want to proceed without saving?',
            },
          ]}
          acceptText="Yes"
          rejectText="No"
          varient="animated"
          rejectButtonStyle={{
            border: '2px solid red',
            color: 'red',

            // "&:focus": { backgroundColor: "red", color: "white" },
          }}
          acceptButtonStyle={{
            border: '2px solid #2bb9bb',
            color: '#2bb9bb',
            // "&:focus": {
            //   background: palette.primary.main,
            //   color: palette.secondary.contrastText,
            // },
          }}
          acceptTransition={{
            transitionTime: '0.2s',
            backgroundColor: 'secondary.contrastText',
            color: 'primary.main',
            hoverBackgroundColor: 'primary.main',
            hoverColor: 'secondary.contrastText',
          }}
          rejectTransition={{
            transitionTime: '0.2s',
            backgroundColor: 'secondary.contrastText',
            color: 'red',
            hoverBackgroundColor: 'red',
            hoverColor: 'secondary.contrastText',
          }}
        />
      )}
      {from === 'dataViewer' && !isOpeningSharedLink ? (
        <>
          {/* <DataViewerMenu
            anchorEl={anchorEl}
            disableEdit={disableEdit}
            handleSave={handleSave}
            openFileMenu={openFileMenu}
            setAnchorEl={setAnchorEl}
            setOpenFileMenu={setOpenFileMenu}
            setSaveFromHomeIcon={setSaveFromHomeIcon}
            setSaveModal={setSaveModal}
          /> */}
          <DataViewerMenu
            anchorEl={anchorEl}
            disableEdit={disableEdit}
            handleSave={handleSave}
            openFileMenu={openFileMenu}
            setAnchorEl={setAnchorEl}
            setOpenFileMenu={setOpenFileMenu}
            setSaveFromHomeIcon={setSaveFromHomeIcon}
            setSaveModal={setSaveModal}
            showListofTileMenu={showListofTileMenu}
            setShowListofTileMenu={setShowListofTileMenu}
            dashboardResizeColumn={dashboardResizeColumn}
            setDashboardResizeColumn={setDashboardResizeColumn}
            showDashboardFilter={showDashboardFilter}
            setShowDashboardFilter={setShowDashboardFilter}
            showDashboardFilterEdit={showDashboardFilterEdit}
            setShowDashboardFilterEdit={setShowDashboardFilterEdit}
            iconAlign={iconAlign}
            setIconAlign={setIconAlign}
            reportFilterMenu={reportFilterMenu}
            setReportFilterMenu={setReportFilterMenu}
            parameterMenu={parameterMenu}
            setParameterMenu={setParameterMenu}
            textColor={menuBarTextColor}
            backgroundColor={menuBarBackgroundColor}
            borderColor={menuBarBorderColor}
          />

          <DataViewerHeader
            showSaveWarning={showSaveWarning}
            disableEdit={disableEdit}
            currPlaybook={currPlaybook}
            setSaveFromHomeIcon={setSaveFromHomeIcon}
            setSaveModal={setSaveModal}
            setOpenSaveCalculationDialogFromHomeIcon={setOpenSaveCalculationDialogFromHomeIcon}
            TextColor={menuBarTextColor}
          />

          <div className="userInfo">
            {(tabState.tabs[tabTileProps.selectedTabId].showDash || tabTileProps.showDash) ? (
              <Select
                size="small"
                open={selectOpen}
                onOpen={() => setSelectOpen(true)}
                onClose={() => {
                  setSelectOpen(false);
                  setTimeout(() => {
                    if (document.activeElement instanceof HTMLElement) {
                      document.activeElement.blur();
                    }
                  }, 0);
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      backgroundColor: menuBarBackgroundColor,
                    },
                  },
                }}
                sx={{
                  height: '1.5rem',
                  fontSize: '12px',
                  width: '8.2rem',
                  margin: 'auto -11px',
                  paddingTop: '2.8px',
                  borderRadius: '2px',
                  color: menubarDropdownColor,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: selectOpen ? '#2bb9bb' : menuBarBorderColor,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: selectOpen ? '#2bb9bb' : menuBarBorderColor,
                  },

                  '& .MuiSelect-icon': {
                    color: menubarDropdownColor,
                  },

                  '& .MuiSelect-select': {
                    color: `${menubarDropdownColor} !important`,
                  },
                }}
                value={tabTileProps.dashMode}
                onChange={(e) => {
                  dispatch(toggleDashMode(e.target.value));
                  // commenting this to avoid dispatching this action so we should respect the dashMode on global level only
                  // dispatch(toggleDashModeInTab(tabTileProps.selectedTabId, e.target.value));
                }}
                renderValue={(selected) => {
                  const iconStyles = {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    paddingBottom: '2px',
                    // Selected value text color
                    color: menubarDropdownColor,
                  };

                  switch (selected) {
                    case 'Edit':
                      return (
                        <div style={{ gap: '5px', ...iconStyles }}>
                          {/* Selected icon color */}
                          <EditIcon
                            fontSize="small"
                            style={{ color: 'inherit', width: '0.9em', marginBottom: '1px' }}
                          />
                          <span>Edit</span>
                        </div>
                      );
                    case 'Present':
                      return (
                        <div style={{ gap: '5px', ...iconStyles }}>
                          <SlideshowIcon
                            fontSize="small"
                            style={{ color: 'inherit', width: '0.9em', marginBottom: '1px' }}
                          />
                          <span>Present</span>
                        </div>
                      );
                    case 'TV Display':
                      return (
                        <div style={{ gap: '5px', ...iconStyles }}>
                          <TvIcon fontSize="small" style={{ color: 'inherit', width: '0.9em' }} />
                          <span>TV Display</span>
                        </div>
                      );
                    default:
                      return <span style={{ color: menuBarTextColor }}>{selected}</span>;
                  }
                }}
              >
                {!disableEdit && (
                  <MenuItem
                    sx={{
                      ...menuStyle,
                      // Default dropdown option color
                      color: menubarDropdownColor,
                      // Selected option styling
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(43, 185, 187, 0.1)',
                        color: menubarDropdownColor,
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'rgba(43, 185, 187, 0.1)',
                      },
                    }}
                    value="Edit"
                  >
                    {/* Icon color matches text color */}
                    <EditIcon
                      fontSize="small"
                      sx={{
                        marginRight: '4px',
                        color: 'inherit', // Inherits from parent MenuItem
                      }}
                    />
                    {selectOpen && 'Edit'}
                  </MenuItem>
                )}
                <MenuItem
                  sx={{
                    ...menuStyle,
                    color: menubarDropdownColor,
                    '&.Mui-selected': {
                      backgroundColor: 'rgba(43, 185, 187, 0.1)',
                      color: menubarDropdownColor,
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'rgba(43, 185, 187, 0.1)',
                    },
                  }}
                  value="Present"
                >
                  <SlideshowIcon fontSize="small" sx={{ marginRight: '4px', color: 'inherit' }} />
                  {selectOpen && 'Present'}
                </MenuItem>
                <MenuItem
                  sx={{
                    ...menuStyle,
                    color: menubarDropdownColor,
                    '&.Mui-selected': {
                      backgroundColor: 'rgba(43, 185, 187, 0.1)',
                      color: menubarDropdownColor,
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'rgba(43, 185, 187, 0.1)',
                    },
                  }}
                  value="TV Display"
                >
                  <TvIcon fontSize="small" sx={{ marginRight: '4px', color: 'inherit' }} />
                  {selectOpen && 'TV Display'}
                </MenuItem>
              </Select>
            ) : null}
          </div>
        </>
      ) : null}

      {!isOpeningSharedLink && (
        <div style={{ borderBottom: 'none' }}>
          <Header
            from={fromRoute.dataViewer}
            saveAndNavigateTo={saveAndNavigateTo}
            backgroundColor={menuBarBackgroundColor}
          />
        </div>
      )}

      <AboutPopover openAbout={aboutPopover} setOpenAbout={setAboutPopover} />
      <PrivacyPopover openPrivacy={privacyPopover} setOpenPrivacy={setPrivacyPopover} />
      {/* A Dialog prompt to save the current playbook. This opens from either of the following actions */}
      {/* 1. When a user clicks save playbook from file menu for the first time */}
      {/* 2. When user clicks Home button and chooses to save changes */}
      {/* 3. When user clicks logout button and chooses to save changes */}
      {/* keep the save modal below this  */}
      <SaveModal
        playBookDescription={playBookDescription}
        playBookName={playBookName}
        subWorkspaceList={subWorkspaceList}
        saveFromHomeIcon={saveFromHomeIcon}
        saveFromLogoutIcon={saveFromLogoutIcon}
        saveModal={saveModal}
        setSaveFromHomeIcon={setSaveFromHomeIcon}
        setSaveFromLogoutIcon={setSaveFromLogoutIcon}
        setSaveModal={setSaveModal}
        setPlayBookDescription={setPlayBookDescription}
        setOpenSaveCalculationDialogFromHomeIcon={setOpenSaveCalculationDialogFromHomeIcon}
        savePlaybook={savePlaybook}
        setPlayBookName={setPlayBookName}
        handleDirectClick={handleDirectClick}
        handleSave={handleSave}
      />
      <NotificationDialog
        openAlert={openAlert}
        severity={severity}
        testMessage={testMessage}
        onCloseAlert={() => {
          setOpenAlert(false);
          setTestMessage('');
        }}
      />
      <PopUpSpinner show={loading} />
    </div>
  );
};

// const mapStateToProps = (state: any, ownProps: any) => {
//   return {
//     playBookState: state.playBookState,
//     token: state.isLogged.accessToken,
//     tabTileProps: state.tabTileProps,
//     tabState: state.tabState,
//     tileState: state.tileState,
//     chartProperty: state.chartProperties,
//     chartControl: state.chartControls,
//     chartGroup: state.chartFilterGroup,
//     dynamicMeasureState: state.dynamicMeasuresState,
//     calculations: state.calculations,
//     dashBoardFilterGroup: state.dashBoardFilterGroup,
//   };
// };

// const mapDispatchToProps = (dispatch: Dispatch<any>) => {
//   return {
//     toggleDashMode: (dashMode: string) => dispatch(toggleDashMode(dashMode)),
//     toggleDashModeInTab: (tabId: number, dashMode: string) =>
//       dispatch(toggleDashModeInTab(tabId, dashMode)),
//     updatePlayBookId: (
//       playBookName: string,
//       playBookUid: string,
//       description: string,
//       oldContent: string | any,
//     ) => dispatch(updatePlaybookUid(playBookName, playBookUid, description, oldContent)),
//     resetAllStates: () => dispatch(resetAllStates()),
//     resetUser: () => dispatch(resetUser()),
//     resetFlatFileState: () => dispatch(resetFlatFileState()),
//     setPageSettings: (option: string, value: any) => dispatch(setPageSettings(option, value)),
//   };
// };

export default MenuBar;
